import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: #162033;
  background: #eef0f2;
  font-family: Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

* {
  box-sizing: border-box;
}

button,
input,
select {
  font: inherit;
}

button,
select {
  cursor: pointer;
}

button:disabled {
  cursor: wait;
  opacity: 0.65;
}

button:focus-visible,
input:focus-visible,
select:focus-visible,
[tabindex="-1"]:focus-visible {
  outline: 3px solid rgba(37, 99, 235, 0.4);
  outline-offset: 3px;
}

.public-wifi-page {
  min-height: 100vh;
  overflow-x: hidden;
  background: radial-gradient(circle at 8% 20%, rgba(71, 85, 105, 0.08), transparent 27rem), linear-gradient(180deg, #e5e7eb 0, #f8fafc 32rem, #eef0f2 100%);
}

.container {
  width: min(1180px, 100% - 40px);
  margin: 0 auto;
}

.hero {
  position: relative;
  min-height: 430px;
  overflow: hidden;
  color: #fff;
  background: linear-gradient(115deg, rgba(24, 24, 27, 0.98), rgba(63, 63, 70, 0.96)), #27272a;
}

.hero::after {
  position: absolute;
  inset: auto 0 0;
  height: 1px;
  content: "";
  background: rgba(255, 255, 255, 0.1);
}

.hero__content {
  position: relative;
  z-index: 1;
  padding-top: 40px;
  padding-bottom: 80px;
}

.hero__glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(2px);
  pointer-events: none;
}

.hero__glow--one {
  width: 560px;
  height: 560px;
  top: -340px;
  right: -90px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.11), rgba(255, 255, 255, 0) 68%);
}

.hero__glow--two {
  width: 420px;
  height: 420px;
  left: 10%;
  bottom: -360px;
  background: radial-gradient(circle, rgba(148, 163, 184, 0.18), rgba(148, 163, 184, 0) 70%);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.brand__icon {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #f4f4f5;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.brand__icon svg {
  width: 24px;
  height: 24px;
}

.hero__copy {
  max-width: 730px;
  margin-top: 54px;
}

.eyebrow,
.section-kicker {
  margin: 0 0 10px;
  color: #64748b;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.hero h1 {
  max-width: 720px;
  margin: 0;
  font-size: clamp(36px, 5vw, 58px);
  font-weight: 780;
  line-height: 1.12;
  letter-spacing: -0.045em;
  word-break: keep-all;
}

.hero h1 span {
  color: #ef4444;
}

.hero__copy > p:last-child {
  max-width: 660px;
  margin: 22px 0 0;
  color: #d4d4d8;
  font-size: 16px;
  line-height: 1.75;
  word-break: keep-all;
}

.privacy-notice {
  display: flex;
  width: fit-content;
  max-width: 700px;
  align-items: flex-start;
  gap: 13px;
  margin-top: 30px;
  padding: 13px 17px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  color: #e4e4e7;
  background: rgba(39, 39, 42, 0.58);
  backdrop-filter: blur(10px);
}

.privacy-notice svg {
  width: 20px;
  min-width: 20px;
  margin-top: 1px;
}

.privacy-notice div {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 9px;
  font-size: 12px;
  line-height: 1.6;
}

.privacy-notice strong {
  color: #fff;
}

.privacy-notice span {
  color: #d4d4d8;
}

.page-content {
  position: relative;
  z-index: 2;
  padding-bottom: 76px;
}

.intro-strip {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: -35px;
  overflow: hidden;
  border: 1px solid #dbe5f0;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 34px rgba(15, 35, 70, 0.09);
}

.intro-strip__item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 18px 20px;
}

.intro-strip__item + .intro-strip__item {
  border-left: 1px solid #e8eef5;
}

.intro-strip__item p {
  margin: 0;
  color: #526176;
  font-size: 12px;
  line-height: 1.5;
}

.info-badge,
.data-origin,
.unsaved-chip {
  display: inline-flex;
  width: max-content;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.info-badge--actual,
.data-origin {
  color: #075985;
  background: #e0f2fe;
}

.info-badge--input {
  color: #1e40af;
  background: #dbeafe;
}

.info-badge--demo {
  color: #7c2d12;
  background: #ffedd5;
}

.top-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(300px, 0.85fr);
  gap: 22px;
  margin-top: 22px;
}

.card {
  min-width: 0;
  border: 1px solid #dce5ef;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(15, 35, 70, 0.06);
}

.network-card,
.demo-card,
.form-card,
.url-card,
.criteria-card {
  padding: 28px;
}

.url-card {
  margin-top: 22px;
}

.url-form {
  margin-top: 22px;
}

.url-input-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
}

.url-input-row input {
  min-width: 0;
  height: 44px;
  padding: 0 14px;
  color: #172033;
  border: 1px solid #cbd6e2;
  border-radius: 10px;
  background: #fff;
  font: inherit;
}

.url-input-row input:focus {
  border-color: #2563eb;
  outline: 3px solid rgba(37, 99, 235, 0.14);
}

.url-result {
  margin-top: 18px;
  padding: 18px;
  border: 1px solid #bbf7d0;
  border-radius: 14px;
  background: #f0fdf4;
}

.url-result--caution {
  border-color: #fde68a;
  background: #fffbeb;
}

.url-result--danger {
  border-color: #fecaca;
  background: #fef2f2;
}

.url-result__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.url-result__summary div {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.url-result__summary span:first-child,
.url-disclaimer {
  color: #64748b;
  font-size: 12px;
}

.url-result__summary strong {
  overflow-wrap: anywhere;
  color: #172033;
}

.url-level,
.url-findings > li > span {
  flex: 0 0 auto;
  padding: 4px 9px;
  color: #334155;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.8);
  font-size: 11px;
  font-weight: 800;
}

.url-findings {
  display: grid;
  gap: 10px;
  margin: 16px 0 0;
  padding: 0;
  list-style: none;
}

.url-findings li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.url-findings strong {
  color: #1e293b;
  font-size: 13px;
}

.url-findings p,
.url-clear,
.url-disclaimer {
  margin: 3px 0 0;
  line-height: 1.55;
}

.url-findings p,
.url-clear {
  color: #475569;
  font-size: 12px;
}

.url-disclaimer {
  margin-top: 12px;
}

.card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.card__header h2,
.limitations h2 {
  margin: 0;
  color: #0d1b2f;
  font-size: 20px;
  font-weight: 760;
  letter-spacing: -0.025em;
}

.card__header p:not(.section-kicker) {
  margin: 8px 0 0;
  color: #65748a;
  font-size: 12px;
  line-height: 1.6;
}

.btn {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 750;
  transition: transform 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.btn svg {
  width: 17px;
  height: 17px;
}

.btn--secondary {
  color: #1d4ed8;
  border: 1px solid #bfd4fa;
  background: #eff6ff;
}

.btn--secondary:hover:not(:disabled) {
  background: #dbeafe;
}

.btn--primary {
  min-width: 160px;
  color: #fff;
  background: #1456d9;
  box-shadow: 0 8px 20px rgba(20, 86, 217, 0.2);
}

.btn--primary:hover:not(:disabled) {
  background: #1048ba;
}

.btn--ghost {
  color: #475569;
  border: 1px solid #d7e0ea;
  background: #fff;
}

.btn--ghost:hover:not(:disabled) {
  background: #f8fafc;
}

.network-primary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 24px;
}

.status-panel {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px;
  border: 1px solid #dbe5ef;
  border-radius: 13px;
  background: #f8fafc;
}

.status-panel__icon {
  display: grid;
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  place-items: center;
  color: #64748b;
  border-radius: 11px;
  background: #e8edf3;
}

.status-panel__icon svg {
  width: 22px;
  height: 22px;
}

.status-panel__text {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}

.status-panel__text span {
  color: #66758a;
  font-size: 13px;
}

.status-panel__text strong {
  color: #27364a;
  font-size: 15px;
}

.status-dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #94a3b8;
  box-shadow: 0 0 0 4px rgba(148, 163, 184, 0.14);
}

.status-panel--online,
.status-panel--secure {
  border-color: #bbebd1;
  background: #f0fdf6;
}

.status-panel--online .status-panel__icon,
.status-panel--secure .status-panel__icon {
  color: #15803d;
  background: #dcfce7;
}

.status-panel--online .status-dot,
.status-panel--secure .status-dot {
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.13);
}

.status-panel--offline {
  border-color: #fed7aa;
  background: #fff7ed;
}

.status-panel--offline .status-panel__icon {
  color: #c2410c;
  background: #ffedd5;
}

.status-panel--offline .status-dot {
  background: #f97316;
  box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.13);
}

.network-details {
  margin: 20px 0 0;
  padding: 0;
  border-top: 1px solid #e8eef5;
}

.detail-row {
  display: grid;
  grid-template-columns: 145px minmax(0, 1fr);
  gap: 14px;
  padding: 12px 2px;
  border-bottom: 1px solid #edf2f7;
  font-size: 12px;
}

.detail-row dt {
  color: #68778b;
}

.detail-row dd {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 0;
  color: #1e293b;
  font-weight: 650;
  text-align: right;
  overflow-wrap: anywhere;
}

.network-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 6px 14px;
  margin-top: 15px;
  color: #718096;
  font-size: 12px;
  line-height: 1.5;
}

.api-note {
  color: #8b5e34;
}

.demo-card {
  display: flex;
  flex-direction: column;
}

.demo-card__description {
  margin: 14px 0 19px;
  color: #5f6f83;
  font-size: 12px;
  line-height: 1.7;
}

.demo-options {
  display: grid;
  gap: 10px;
}

.demo-button {
  display: flex;
  width: 100%;
  min-height: 62px;
  align-items: center;
  gap: 13px;
  padding: 11px 13px;
  text-align: left;
  border: 1px solid #dce5ef;
  border-radius: 12px;
  background: #fff;
  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease;
}

.demo-button:hover {
  transform: translateY(-1px);
  border-color: #94a3b8;
  background: #f8fafc;
}

.demo-button.is-active {
  border-color: #2563eb;
  background: #eff6ff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.08);
}

.demo-button__icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 850;
}

.demo-button--safe .demo-button__icon {
  color: #15803d;
  background: #dcfce7;
}

.demo-button--normal .demo-button__icon {
  color: #a16207;
  background: #fef9c3;
}

.demo-button--danger .demo-button__icon {
  color: #b91c1c;
  background: #fee2e2;
}

.demo-button > span:last-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.demo-button strong {
  color: #1e293b;
  font-size: 12px;
}

.demo-button small {
  color: #718096;
  font-size: 12px;
}

.demo-disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: auto;
  padding-top: 19px;
  color: #8a5b25;
  font-size: 12px;
  line-height: 1.55;
}

.demo-disclaimer svg {
  width: 16px;
  min-width: 16px;
}

.form-card {
  margin-top: 22px;
}

.card__header--split {
  padding-bottom: 22px;
  border-bottom: 1px solid #e8eef5;
}

.unsaved-chip {
  color: #166534;
  border: 1px solid #bbebd1;
  background: #f0fdf4;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px 18px;
  padding-top: 24px;
}

.field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}

.field--wide {
  grid-column: span 2;
}

.field label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #26364b;
  font-size: 12px;
  font-weight: 700;
}

.field label small {
  color: #8a97a8;
  font-size: 12px;
  font-weight: 500;
}

.field input,
.field select {
  width: 100%;
  height: 44px;
  padding: 0 13px;
  color: #1f2937;
  border: 1px solid #ccd8e5;
  border-radius: 10px;
  outline: none;
  background: #fff;
  font-size: 12px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.field select {
  padding-right: 36px;
}

.field input::placeholder {
  color: #9aa7b8;
}

.field input:hover,
.field select:hover {
  border-color: #9fb0c4;
}

.field input:focus,
.field select:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.field__help {
  margin: -1px 0 0;
  color: #7b8798;
  font-size: 12px;
  line-height: 1.5;
}

.https-context {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 22px;
  padding: 14px 16px;
  border: 1px solid #d9e5f2;
  border-radius: 12px;
  background: #f8fbff;
}

.https-context__icon {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
  place-items: center;
  color: #1d4ed8;
  border-radius: 10px;
  background: #dbeafe;
}

.https-context__icon svg {
  width: 20px;
  height: 20px;
}

.https-context > div:nth-child(2) {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 3px;
}

.https-context span {
  color: #68778b;
  font-size: 12px;
}

.https-context strong {
  color: #1e293b;
  font-size: 12px;
}

.form-error {
  margin: 14px 0 0;
  padding: 11px 13px;
  color: #991b1b;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fef2f2;
  font-size: 13px;
}

.form-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 22px;
}

.result-card {
  margin-top: 22px;
  overflow: hidden;
}

.result-summary {
  display: flex;
  min-height: 250px;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 34px 42px;
  color: #fff;
  background: radial-gradient(circle at 85% 15%, rgba(239, 68, 68, 0.12), transparent 17rem), linear-gradient(118deg, #18181b 0%, #3f3f46 100%);
}

.result-copy {
  max-width: 650px;
}

.result-copy h2 {
  margin: 0;
  font-size: 25px;
  font-weight: 760;
  letter-spacing: -0.03em;
}

.grade-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.grade-line > span:last-child {
  color: #d4d4d8;
  font-size: 13px;
  line-height: 1.55;
}

.grade-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 11px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.1);
}

.grade-badge span {
  font-size: 12px;
}

.grade-very-safe span {
  color: #22c55e;
}

.grade-safe span {
  color: #84cc16;
}

.grade-caution span {
  color: #facc15;
}

.grade-danger span {
  color: #fb923c;
}

.grade-critical span {
  color: #f87171;
}

.basis-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
  color: #a1a1aa;
  font-size: 12px;
}

.basis-row strong {
  color: #f4f4f5;
}

.gauge-wrap {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.gauge {
  display: grid;
  width: 170px;
  height: 170px;
  place-items: center;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.13), 0 14px 34px rgba(0, 0, 0, 0.25);
  transition: background 0.4s ease;
}

.gauge__inner {
  display: flex;
  width: 132px;
  height: 132px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 50%;
  background: #27272a;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
}

.gauge__inner strong {
  color: #fff;
  font-size: 50px;
  font-weight: 790;
  line-height: 1;
  letter-spacing: -0.055em;
}

.gauge__inner span {
  margin-top: 5px;
  color: #a1a1aa;
  font-size: 13px;
}

.gauge-wrap p {
  margin: 0;
  color: #fff;
  font-size: 13px;
  font-weight: 750;
}

.result-body {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
}

.breakdown-panel,
.risk-panel {
  min-width: 0;
  padding: 32px;
}

.breakdown-panel {
  border-right: 1px solid #e5ebf2;
}

.breakdown-panel h3,
.risk-panel h3 {
  margin: 0;
  color: #16253a;
  font-size: 16px;
  font-weight: 760;
  letter-spacing: -0.02em;
}

.breakdown-panel > p,
.risk-panel__heading p {
  margin: 7px 0 0;
  color: #718096;
  font-size: 12px;
  line-height: 1.55;
}

.breakdown-list {
  display: grid;
  gap: 16px;
  margin-top: 23px;
}

.breakdown-item__top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}

.breakdown-item__top > span {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.breakdown-item__top strong {
  color: #334155;
}

.breakdown-item__top small {
  color: #8390a2;
  font-size: 12px;
}

.breakdown-item__top b {
  color: #16253a;
  font-size: 13px;
  white-space: nowrap;
}

.score-bar {
  height: 5px;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e7edf4;
}

.score-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  transition: width 0.35s ease, background-color 0.35s ease;
}

.risk-panel__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.risk-count {
  padding: 4px 8px;
  color: #526176;
  border-radius: 999px;
  background: #eef2f7;
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
}

.risk-list {
  display: grid;
  gap: 10px;
  margin-top: 20px;
}

.risk-item {
  padding: 14px 15px;
  border: 1px solid #e0e7ef;
  border-left: 3px solid #64748b;
  border-radius: 10px;
  background: #fbfcfe;
}

.risk-item--medium {
  border-left-color: #eab308;
  background: #fffef5;
}

.risk-item--high {
  border-left-color: #f97316;
  background: #fff9f5;
}

.risk-item--critical {
  border-left-color: #dc2626;
  background: #fff7f7;
}

.risk-item__top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.risk-level {
  padding: 3px 6px;
  color: #475569;
  border-radius: 5px;
  background: #e8edf3;
  font-size: 12px;
  font-weight: 800;
}

.risk-item--medium .risk-level {
  color: #854d0e;
  background: #fef9c3;
}

.risk-item--high .risk-level {
  color: #9a3412;
  background: #ffedd5;
}

.risk-item--critical .risk-level {
  color: #991b1b;
  background: #fee2e2;
}

.risk-item h4 {
  margin: 0;
  color: #27364a;
  font-size: 12px;
  font-weight: 760;
}

.risk-item > p {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.55;
}

.risk-action {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 9px;
  color: #1e40af;
  font-size: 12px;
  line-height: 1.5;
}

.education-note {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 30px;
  color: #5f6f83;
  border-top: 1px solid #e6edf4;
  background: #f8fafc;
}

.education-note svg {
  width: 18px;
  min-width: 18px;
  color: #1d4ed8;
}

.education-note p {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
}

.criteria-card {
  margin-top: 22px;
}

.criteria-table-wrap {
  margin-top: 22px;
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.criteria-table-wrap table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
  font-size: 13px;
}

.criteria-table-wrap th,
.criteria-table-wrap td {
  padding: 13px 15px;
  text-align: left;
  border-bottom: 1px solid #e8eef5;
}

.criteria-table-wrap thead th {
  color: #526176;
  background: #f7f9fc;
  font-size: 12px;
  font-weight: 750;
}

.criteria-table-wrap tbody th {
  width: 145px;
  color: #26364b;
  font-weight: 700;
}

.criteria-table-wrap tbody td {
  color: #64748b;
}

.criteria-table-wrap tr:last-child th,
.criteria-table-wrap tr:last-child td {
  border-bottom: 0;
}

.criteria-table-wrap th:last-child,
.criteria-table-wrap td:last-child {
  width: 70px;
  text-align: right;
  white-space: nowrap;
}

.grade-scale {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 6px;
  margin-top: 22px;
}

.grade-scale__item {
  display: flex;
  min-height: 57px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  color: #fff;
  border-radius: 9px;
}

.grade-scale__item strong {
  font-size: 13px;
}

.grade-scale__item span {
  font-size: 12px;
  font-weight: 700;
}

.grade-scale__item--critical {
  background: #b91c1c;
}

.grade-scale__item--danger {
  background: #ea580c;
}

.grade-scale__item--caution {
  color: #422006;
  background: #facc15;
}

.grade-scale__item--safe {
  color: #25370a;
  background: #84cc16;
}

.grade-scale__item--very-safe {
  background: #15803d;
}

.criteria-footnote {
  margin: 15px 0 0;
  color: #718096;
  font-size: 12px;
  line-height: 1.55;
}

.limitations {
  display: grid;
  grid-template-columns: minmax(230px, 0.7fr) minmax(0, 1.3fr);
  gap: 34px;
  margin-top: 22px;
  padding: 30px;
  color: #e4e4e7;
  border: 1px solid rgba(161, 161, 170, 0.24);
  border-radius: 20px;
  background: #27272a;
  box-shadow: 0 8px 28px rgba(39, 39, 42, 0.12);
}

.limitations__heading {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.limitations__heading > span {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  place-items: center;
  color: #e4e4e7;
  border: 1px solid rgba(212, 212, 216, 0.25);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  font-family: serif;
  font-weight: 700;
}

.limitations h2 {
  color: #fff;
  font-size: 17px;
}

.limitations__heading p {
  margin: 8px 0 0;
  color: #a1a1aa;
  font-size: 12px;
  line-height: 1.55;
}

.limitations-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.limitations-column {
  padding: 17px;
  border: 1px solid rgba(212, 212, 216, 0.15);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
}

.limitations-column h3 {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  color: #fff;
  font-size: 13px;
}

.check-icon,
.lock-icon {
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  border-radius: 50%;
  font-size: 12px;
}

.check-icon {
  color: #bbf7d0;
  background: rgba(34, 197, 94, 0.18);
}

.lock-icon {
  color: #fde68a;
  background: rgba(234, 179, 8, 0.18);
}

.limitations-column ul {
  display: grid;
  gap: 8px;
  margin: 13px 0 0;
  padding: 0;
  color: #d4d4d8;
  font-size: 12px;
  line-height: 1.45;
  list-style: none;
}

.limitations-column li {
  position: relative;
  padding-left: 12px;
}

.limitations-column li::before {
  position: absolute;
  top: 0.6em;
  left: 0;
  width: 3px;
  height: 3px;
  content: "";
  border-radius: 50%;
  background: #a1a1aa;
}

.footer {
  color: #a1a1aa;
  background: #18181b;
}

.footer__content {
  display: flex;
  min-height: 110px;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}

.footer__brand {
  display: flex;
  align-items: center;
  gap: 11px;
}

.footer__shield {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  color: #f4f4f5;
  border: 1px solid rgba(212, 212, 216, 0.25);
  border-radius: 10px 10px 13px 13px;
  background: rgba(255, 255, 255, 0.08);
  font-size: 12px;
  font-weight: 850;
}

.footer__brand div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.footer__brand strong {
  color: #f4f4f5;
  font-size: 13px;
}

.footer__brand span,
.footer p {
  font-size: 12px;
}

.footer p {
  max-width: 420px;
  margin: 0;
  line-height: 1.55;
  text-align: right;
}

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

@media (max-width: 900px) {
  .hero {
    min-height: 400px;
  }
  .top-grid,
  .result-body,
  .limitations {
    grid-template-columns: 1fr;
  }
  .demo-card {
    min-height: auto;
  }
  .demo-disclaimer {
    margin-top: 16px;
  }
  .form-grid {
    grid-template-columns: 1fr 1fr;
  }
  .field--wide {
    grid-column: span 2;
  }
  .breakdown-panel {
    border-right: 0;
    border-bottom: 1px solid #e5ebf2;
  }
  .limitations-grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 680px) {
  .container {
    width: min(100% - 28px, 1180px);
  }
  .hero {
    min-height: auto;
  }
  .hero__content {
    padding-top: 25px;
    padding-bottom: 68px;
  }
  .hero__copy {
    margin-top: 42px;
  }
  .hero h1 {
    font-size: 36px;
  }
  .hero__copy > p:last-child {
    font-size: 14px;
  }
  .privacy-notice {
    width: 100%;
  }
  .privacy-notice div {
    flex-direction: column;
  }
  .intro-strip {
    grid-template-columns: 1fr;
    margin-top: -28px;
  }
  .intro-strip__item {
    padding: 13px 16px;
  }
  .intro-strip__item + .intro-strip__item {
    border-top: 1px solid #e8eef5;
    border-left: 0;
  }
  .top-grid {
    gap: 14px;
    margin-top: 14px;
  }
  .network-card,
  .demo-card,
  .form-card,
  .url-card,
  .criteria-card {
    padding: 20px;
    border-radius: 16px;
  }
  .card__header {
    gap: 12px;
  }
  .network-primary {
    grid-template-columns: 1fr;
  }
  .detail-row {
    grid-template-columns: 105px minmax(0, 1fr);
  }
  .form-card,
  .url-card,
  .result-card,
  .criteria-card,
  .limitations {
    margin-top: 14px;
  }
  .form-grid {
    grid-template-columns: 1fr;
    gap: 17px;
  }
  .field--wide {
    grid-column: auto;
  }
  .https-context {
    align-items: flex-start;
  }
  .https-context > .info-badge {
    margin-left: auto;
  }
  .form-actions {
    display: grid;
    grid-template-columns: 1fr;
  }
  .url-input-row {
    grid-template-columns: 1fr;
  }
  .btn--primary {
    width: 100%;
  }
  .result-summary {
    min-height: 0;
    align-items: flex-start;
    flex-direction: column;
    padding: 28px 22px;
  }
  .gauge-wrap {
    width: 100%;
  }
  .gauge {
    width: 154px;
    height: 154px;
  }
  .gauge__inner {
    width: 120px;
    height: 120px;
  }
  .gauge__inner strong {
    font-size: 44px;
  }
  .breakdown-panel,
  .risk-panel {
    padding: 24px 20px;
  }
  .education-note {
    align-items: flex-start;
    padding: 14px 20px;
  }
  .grade-scale {
    grid-template-columns: repeat(5, minmax(76px, 1fr));
    overflow-x: auto;
    padding-bottom: 5px;
  }
  .criteria-table-wrap {
    width: 100%;
  }
  .limitations {
    gap: 22px;
    padding: 22px 20px;
    border-radius: 16px;
  }
  .limitations-grid {
    grid-template-columns: 1fr;
  }
  .footer__content {
    min-height: 135px;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    gap: 16px;
    padding-top: 26px;
    padding-bottom: 26px;
  }
  .footer p {
    text-align: left;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
/* Dark neutral surfaces use light neutral section labels for contrast. */
.hero .eyebrow,
.result-summary .section-kicker {
  color: #d4d4d8;
}`],
})
export class PageAccessComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {
        // 첫 렌더링부터 하드코딩된 임시값 대신 실제 기본 선택값을 표시한다.
        this.calculateScore(false);
    }

    public readonly IP_API_URL: string = 'https://api.ipify.org?format=json';

    public network: any = {
        online: navigator.onLine,
        https: location.protocol === 'https:',
        publicIp: '확인 중',
        ipStatus: 'loading',
        effectiveType: '브라우저에서 지원하지 않음',
        downlink: '브라우저에서 지원하지 않음',
        rtt: '브라우저에서 지원하지 않음',
        saveData: '브라우저에서 지원하지 않음',
        checkedAt: '-'
    };

    public form: any = {
        ssid: '',
        networkType: 'public',
        encryption: 'unknown',
        authType: 'unknown',
        vpn: 'unknown',
        autoConnect: 'unknown',
        sharing: 'unknown'
    };

    public scoreRules: any = {
        encryption: {
            label: '암호화 방식',
            max: 35,
            values: {
                wpa3: { score: 35, label: 'WPA3' },
                wpa2: { score: 28, label: 'WPA2' },
                wpa: { score: 15, label: 'WPA' },
                wep: { score: 5, label: 'WEP' },
                open: { score: 0, label: '개방형' },
                unknown: { score: 10, label: '모름' }
            }
        },
        https: {
            label: 'HTTPS 연결',
            max: 20,
            values: {
                yes: { score: 20, label: 'HTTPS' },
                no: { score: 0, label: 'HTTP' }
            }
        },
        vpn: {
            label: 'VPN 사용',
            max: 15,
            values: {
                yes: { score: 15, label: '사용' },
                no: { score: 0, label: '미사용' },
                unknown: { score: 5, label: '모름' }
            }
        },
        authType: {
            label: '로그인 및 인증',
            max: 10,
            values: {
                individual: { score: 10, label: '개인별 인증' },
                shared: { score: 6, label: '공용 비밀번호' },
                captive: { score: 4, label: '캡티브 포털' },
                none: { score: 0, label: '없음' },
                unknown: { score: 3, label: '모름' }
            }
        },
        autoConnect: {
            label: '자동 연결 설정',
            max: 10,
            values: {
                off: { score: 10, label: '꺼짐' },
                on: { score: 0, label: '켜짐' },
                unknown: { score: 3, label: '모름' }
            }
        },
        sharing: {
            label: '파일 공유 및 검색',
            max: 10,
            values: {
                no: { score: 10, label: '비활성화' },
                yes: { score: 0, label: '활성화' },
                unknown: { score: 3, label: '모름' }
            }
        }
    };

    public result: any = {
        score: 41,
        grade: '보통',
        color: '#eab308',
        colorClass: 'grade-caution',
        message: '확인되지 않은 항목이 있습니다.',
        breakdown: [],
        risks: []
    };

    public demoMode: string = '';
    public demoHttps: boolean | null = null;
    public isCalculating: boolean = false;
    public statusMessage: string = '';
    public validationMessage: string = '';
    public urlInput: string = '';
    public urlCheck: any = null;
    public urlError: string = '';

    private connection: any = null;
    private onlineHandler = async () => {
        this.network.online = true;
        this.setCheckedAt();
        this.statusMessage = '인터넷 연결 상태가 온라인으로 변경되었습니다.';
        await this.service.render();
    };
    private offlineHandler = async () => {
        this.network.online = false;
        this.network.publicIp = '확인할 수 없음';
        this.network.ipStatus = 'error';
        this.setCheckedAt();
        this.statusMessage = '인터넷 연결 상태가 오프라인으로 변경되었습니다.';
        await this.service.render();
    };
    private connectionHandler = async () => {
        this.readConnectionInfo();
        this.setCheckedAt();
        await this.service.render();
    };

    public async ngOnInit() {
        await this.service.init();
        window.addEventListener('online', this.onlineHandler);
        window.addEventListener('offline', this.offlineHandler);

        this.connection = (navigator as any).connection ||
            (navigator as any).mozConnection ||
            (navigator as any).webkitConnection;

        if (this.connection && this.connection.addEventListener) {
            this.connection.addEventListener('change', this.connectionHandler);
        }

        await this.inspectNetwork();
    }

    public ngOnDestroy() {
        window.removeEventListener('online', this.onlineHandler);
        window.removeEventListener('offline', this.offlineHandler);
        if (this.connection && this.connection.removeEventListener) {
            this.connection.removeEventListener('change', this.connectionHandler);
        }
    }

    public get scoreUsesHttps(): boolean {
        return this.demoHttps === null ? this.network.https : this.demoHttps;
    }

    public get gaugeBackground(): string {
        return 'conic-gradient(' + this.result.color + ' ' + (this.result.score * 3.6) + 'deg, #e2e8f0 0deg)';
    }

    public get riskCount(): number {
        return this.result.risks.filter((risk: any) => risk.severity > 1).length;
    }

    public get httpsScoreLabel(): string {
        if (this.demoHttps === null) {
            return this.network.https ? '실제 HTTPS' : '실제 HTTP';
        }
        return this.demoHttps ? '모의 HTTPS' : '모의 HTTP';
    }

    public async inspectNetwork() {
        this.isCalculating = true;
        this.network.online = navigator.onLine;
        this.network.https = location.protocol === 'https:';
        this.readConnectionInfo();
        this.setCheckedAt();
        await this.calculateScore(false);
        await this.service.render();

        if (this.network.online) {
            await this.fetchPublicIp();
        } else {
            this.network.publicIp = '확인할 수 없음';
            this.network.ipStatus = 'error';
        }

        this.isCalculating = false;
        this.statusMessage = '네트워크 상태를 다시 확인했습니다.';
        await this.service.render();
    }

    private readConnectionInfo() {
        if (!this.connection) {
            this.network.effectiveType = '브라우저에서 지원하지 않음';
            this.network.downlink = '브라우저에서 지원하지 않음';
            this.network.rtt = '브라우저에서 지원하지 않음';
            this.network.saveData = '브라우저에서 지원하지 않음';
            return;
        }

        this.network.effectiveType = this.connection.effectiveType || '확인할 수 없음';
        this.network.downlink = typeof this.connection.downlink === 'number'
            ? this.connection.downlink + ' Mbps'
            : '확인할 수 없음';
        this.network.rtt = typeof this.connection.rtt === 'number'
            ? this.connection.rtt + ' ms'
            : '확인할 수 없음';
        this.network.saveData = typeof this.connection.saveData === 'boolean'
            ? (this.connection.saveData ? '사용 중' : '사용 안 함')
            : '확인할 수 없음';
    }

    private async fetchPublicIp() {
        this.network.publicIp = '확인 중';
        this.network.ipStatus = 'loading';

        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const timeout = window.setTimeout(() => {
            if (controller) controller.abort();
        }, 6000);

        try {
            const options: any = {
                method: 'GET',
                cache: 'no-store',
                headers: { 'Accept': 'application/json' }
            };
            if (controller) options.signal = controller.signal;

            const response = await fetch(this.IP_API_URL, options);
            if (!response.ok) throw new Error('IP API response error');

            const payload = await response.json();
            const ip = payload && typeof payload.ip === 'string' ? payload.ip.trim() : '';
            if (!ip || ip.length > 64 || !/^[0-9a-fA-F:.]+$/.test(ip)) {
                throw new Error('Invalid IP response');
            }

            this.network.publicIp = ip;
            this.network.ipStatus = 'success';
        } catch (error) {
            this.network.publicIp = '확인할 수 없음';
            this.network.ipStatus = 'error';
        } finally {
            window.clearTimeout(timeout);
        }
    }

    private setCheckedAt() {
        this.network.checkedAt = new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date());
    }

    public async inspectUrl() {
        const input = this.urlInput.trim();
        this.urlError = '';
        this.urlCheck = null;

        if (!input) {
            this.urlError = '검사할 URL을 입력해 주세요.';
        } else if (input.length > 2048) {
            this.urlError = 'URL은 2,048자 이하로 입력해 주세요.';
        } else {
            try {
                const candidate = /^[a-z][a-z0-9+.-]*:\/\//i.test(input) ? input : 'https://' + input;
                const url = new URL(candidate);
                if (url.protocol !== 'http:' && url.protocol !== 'https:') {
                    throw new Error('unsupported protocol');
                }

                const host = url.hostname.toLowerCase().replace(/^\[|\]$/g, '');
                if (!host || /\s/.test(host)) throw new Error('invalid host');

                const findings: any[] = [];
                const add = (level: string, title: string, detail: string) => findings.push({ level, title, detail });
                if (url.protocol === 'http:') add('높음', 'HTTP 주소', '전송 내용이 암호화되지 않습니다. HTTPS 주소인지 다시 확인하세요.');
                if (this.isIpHost(host)) add('높음', 'IP 주소 직접 사용', '일반 도메인 대신 IP 주소를 사용합니다. 공식 사이트에서 주소를 다시 확인하세요.');
                if (input.indexOf('@') >= 0 || url.username || url.password) add('높음', '@ 기호 또는 사용자 정보', '@ 앞부분이 실제 접속 도메인처럼 보이게 URL을 위장할 수 있습니다.');

                const labels = host.split('.').filter(Boolean);
                if (labels.length > 4) add('주의', '과도한 서브도메인', '호스트가 ' + labels.length + '단계로 길어 실제 등록 도메인을 숨길 수 있습니다.');
                if (host.indexOf('xn--') >= 0) add('주의', '국제화 도메인', '비슷하게 보이는 다른 문자로 만든 주소일 수 있습니다.');

                const similar = this.findSimilarBrand(labels.length > 1 ? labels[labels.length - 2] : labels[0]);
                if (similar) add('주의', '유사 도메인 의심', '도메인 이름이 유명 서비스 ‘' + similar + '’와 비슷합니다.');

                this.urlCheck = {
                    host,
                    normalized: url.protocol + '//' + url.host,
                    findings,
                    level: findings.some((item: any) => item.level === '높음') ? '위험' : findings.length ? '주의' : '특이점 없음'
                };
            } catch (error) {
                this.urlError = '올바른 HTTP 또는 HTTPS URL을 입력해 주세요.';
            }
        }

        this.statusMessage = this.urlError || 'URL 간이 검사가 완료되었습니다. 결과는 ' + this.urlCheck.level + '입니다.';
        await this.service.render();
    }

    private isIpHost(host: string): boolean {
        if (host.indexOf(':') >= 0) return true;
        const parts = host.split('.');
        return parts.length === 4 && parts.every((part: string) => /^\d{1,3}$/.test(part) && Number(part) <= 255);
    }

    private findSimilarBrand(label: string): string {
        const brands = ['google', 'naver', 'kakao', 'microsoft', 'apple', 'amazon', 'paypal', 'netflix', 'facebook', 'instagram'];
        const folded = (label || '').replace(/[0]/g, 'o').replace(/[1]/g, 'i').replace(/[3]/g, 'e').replace(/[5]/g, 's');
        for (const brand of brands) {
            if (label !== brand && (folded === brand || this.editDistance(label, brand) === 1)) return brand;
        }
        return '';
    }

    private editDistance(a: string, b: string): number {
        let row = Array.from({ length: b.length + 1 }, (_: any, index: number) => index);
        for (let i = 1; i <= a.length; i++) {
            const next = [i];
            for (let j = 1; j <= b.length; j++) {
                next[j] = Math.min(next[j - 1] + 1, row[j] + 1, row[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
            }
            row = next;
        }
        return row[b.length];
    }

    public async calculateScore(announce: boolean = true) {
        this.validationMessage = '';

        const selections = [
            this.form.encryption,
            this.form.authType,
            this.form.vpn,
            this.form.autoConnect,
            this.form.sharing
        ];

        if (selections.some((value: string) => !value)) {
            this.validationMessage = '모든 보안 항목을 선택해 주세요. 모르는 항목은 ‘모름’을 선택할 수 있습니다.';
            if (announce) {
                this.statusMessage = this.validationMessage;
                await this.service.render();
            }
            return;
        }

        const httpsKey = this.scoreUsesHttps ? 'yes' : 'no';
        const inputMap: any = {
            encryption: this.form.encryption,
            https: httpsKey,
            vpn: this.form.vpn,
            authType: this.form.authType,
            autoConnect: this.form.autoConnect,
            sharing: this.form.sharing
        };

        const order = ['encryption', 'https', 'vpn', 'authType', 'autoConnect', 'sharing'];
        const breakdown: any[] = [];
        let total = 0;

        order.forEach((key: string) => {
            const rule = this.scoreRules[key];
            const selected = rule.values[inputMap[key]];
            const score = selected ? selected.score : 0;
            total += score;
            breakdown.push({
                key: key,
                label: rule.label,
                selection: selected ? selected.label : '확인되지 않음',
                score: score,
                max: rule.max,
                percent: Math.round((score / rule.max) * 100)
            });
        });

        total = Math.max(0, Math.min(100, total));
        const grade = this.getGrade(total);

        this.result = {
            score: total,
            grade: grade.label,
            color: grade.color,
            colorClass: grade.colorClass,
            message: grade.message,
            breakdown: breakdown,
            risks: this.buildRisks()
        };

        if (announce) {
            this.statusMessage = '안전도 계산이 완료되었습니다. ' + total + '점, ' + grade.label + ' 등급입니다.';
            await this.service.render();
            window.setTimeout(() => {
                const target = document.getElementById('safety-result');
                if (target) target.focus();
            }, 0);
        }
    }

    private getGrade(score: number): any {
        if (score >= 81) {
            return {
                label: '매우 안전',
                color: '#15803d',
                colorClass: 'grade-very-safe',
                message: '현재 설정은 공공 와이파이 이용 시 권장되는 보호 수준에 가깝습니다.'
            };
        }
        if (score >= 61) {
            return {
                label: '안전',
                color: '#65a30d',
                colorClass: 'grade-safe',
                message: '대체로 안전하지만 아래 위험 요소와 권장 행동을 확인하세요.'
            };
        }
        if (score >= 41) {
            return {
                label: '보통',
                color: '#ca8a04',
                colorClass: 'grade-caution',
                message: '일부 보안 설정을 확인하거나 개선할 필요가 있습니다.'
            };
        }
        if (score >= 21) {
            return {
                label: '위험',
                color: '#ea580c',
                colorClass: 'grade-danger',
                message: '민감한 작업을 피하고 즉시 보호 조치를 적용하세요.'
            };
        }
        return {
            label: '매우 위험',
            color: '#dc2626',
            colorClass: 'grade-critical',
            message: '이 네트워크에서 금융 거래나 비밀번호 입력을 중단하세요.'
        };
    }

    private buildRisks(): any[] {
        const risks: any[] = [];

        const add = (severity: number, level: string, title: string, reason: string, action: string) => {
            risks.push({ severity: severity, level: level, title: title, reason: reason, action: action });
        };

        if (!this.scoreUsesHttps) {
            add(5, '매우 높음', 'HTTP 연결 사용', '전송 내용이 암호화되지 않아 같은 네트워크의 공격자에게 노출될 수 있습니다.', '주소창의 자물쇠와 HTTPS를 확인하고 민감한 정보 입력을 중단하세요.');
        }

        if (this.form.encryption === 'open') {
            add(5, '매우 높음', '개방형 와이파이', '와이파이 구간의 데이터가 암호화되지 않습니다.', 'VPN을 사용하거나 모바일 데이터·개인 핫스팟으로 전환하세요.');
        } else if (this.form.encryption === 'wep') {
            add(5, '매우 높음', '취약한 WEP 암호화', 'WEP는 짧은 시간 안에 무력화될 수 있는 오래된 방식입니다.', '이 네트워크 사용을 중단하고 WPA2 이상인 네트워크를 선택하세요.');
        } else if (this.form.encryption === 'wpa') {
            add(4, '높음', '오래된 WPA 암호화', 'WPA는 현재 권장 기준보다 보호 수준이 낮습니다.', '가능하면 WPA2 또는 WPA3 네트워크를 사용하세요.');
        } else if (this.form.encryption === 'unknown') {
            add(2, '확인 필요', '암호화 방식 미확인', '보안 방식을 모르면 개방형 또는 취약한 네트워크인지 판단하기 어렵습니다.', '네트워크 제공자에게 암호화 방식을 확인하세요.');
        }

        if (this.form.vpn === 'no') {
            add(4, '높음', 'VPN 미사용', '공공망에서는 암호화되지 않은 트래픽과 메타데이터가 노출될 위험이 커집니다.', '신뢰할 수 있는 VPN을 켠 뒤 이용하세요.');
        } else if (this.form.vpn === 'unknown') {
            add(2, '확인 필요', 'VPN 상태 미확인', 'VPN 보호 여부를 확인하지 못했습니다.', '기기의 VPN 설정 또는 상태 표시를 확인하세요.');
        }

        if (this.form.authType === 'none') {
            add(4, '높음', '네트워크 인증 없음', '누구나 접속할 수 있어 악성 사용자가 같은 망에 있을 가능성이 높습니다.', '금융 거래를 피하고 가능한 경우 개인 핫스팟을 사용하세요.');
        } else if (this.form.authType === 'captive') {
            add(3, '주의', '캡티브 포털 사용', '로그인 화면 자체가 네트워크 암호화를 보장하지는 않습니다.', '포털 주소와 인증서를 확인하고 재사용하는 비밀번호를 입력하지 마세요.');
        } else if (this.form.authType === 'unknown') {
            add(2, '확인 필요', '인증 방식 미확인', '접속자를 구분하는 보호 장치가 있는지 알 수 없습니다.', '시설 안내문이나 네트워크 제공자에게 인증 방식을 확인하세요.');
        }

        if (this.form.autoConnect === 'on') {
            add(3, '주의', '자동 연결 켜짐', '동일한 이름의 위조 네트워크에 자동으로 연결될 수 있습니다.', '자동 연결을 끄고 사용 후 해당 와이파이 네트워크를 삭제하세요.');
        } else if (this.form.autoConnect === 'unknown') {
            add(2, '확인 필요', '자동 연결 설정 미확인', '기기가 이후 같은 이름의 네트워크에 자동 연결될 수 있습니다.', '와이파이 상세 설정에서 자동 연결을 확인하세요.');
        }

        if (this.form.sharing === 'yes') {
            add(4, '높음', '파일 공유 또는 네트워크 검색 활성화', '같은 네트워크의 다른 기기가 공유 자원이나 기기를 발견할 수 있습니다.', '파일 공유와 네트워크 검색을 즉시 끄세요.');
        } else if (this.form.sharing === 'unknown') {
            add(2, '확인 필요', '공유 설정 미확인', '공유 기능이 켜져 있으면 기기가 같은 네트워크에 노출될 수 있습니다.', '운영체제의 네트워크 공유 설정을 확인해 끄세요.');
        }

        if (risks.length === 0) {
            add(1, '낮음', '뚜렷한 위험 요소 없음', '입력한 항목에서는 주요 위험 요소가 발견되지 않았습니다.', 'HTTPS 자물쇠를 계속 확인하고 사용 후 공공 와이파이를 삭제하세요.');
        }

        return risks.sort((a: any, b: any) => b.severity - a.severity);
    }

    public async loadDemo(mode: string) {
        this.demoMode = mode;

        if (mode === 'safe') {
            this.form = {
                ssid: '도서관 보안 Wi-Fi (시연)',
                networkType: 'public',
                encryption: 'wpa3',
                authType: 'individual',
                vpn: 'yes',
                autoConnect: 'off',
                sharing: 'no'
            };
            this.demoHttps = true;
        } else if (mode === 'normal') {
            this.form = {
                ssid: '카페 공용 Wi-Fi (시연)',
                networkType: 'public',
                encryption: 'wpa2',
                authType: 'shared',
                vpn: 'no',
                autoConnect: 'on',
                sharing: 'no'
            };
            this.demoHttps = true;
        } else {
            this.form = {
                ssid: 'FREE_WIFI (시연)',
                networkType: 'public',
                encryption: 'open',
                authType: 'none',
                vpn: 'no',
                autoConnect: 'on',
                sharing: 'yes'
            };
            this.demoHttps = false;
        }

        await this.calculateScore(false);
        this.statusMessage = '시연 모드 ‘' + (mode === 'safe' ? '안전한 사례' : mode === 'normal' ? '보통 사례' : '위험한 사례') + '’를 불러왔습니다.';
        await this.service.render();
    }

    public async reset() {
        this.form = {
            ssid: '',
            networkType: 'public',
            encryption: 'unknown',
            authType: 'unknown',
            vpn: 'unknown',
            autoConnect: 'unknown',
            sharing: 'unknown'
        };
        this.demoMode = '';
        this.demoHttps = null;
        this.validationMessage = '';
        await this.calculateScore(false);
        this.statusMessage = '사용자 입력과 시연 결과를 초기화했습니다.';
        await this.service.render();
    }
}

export default PageAccessComponent;